import { Location } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { filter, firstValueFrom } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { AccountingSystemEnums } from 'src/app/enum/accouting-system-enums';
import { FormatsEnums } from 'src/app/enum/formats-enums';
import { GeneralParameterEnums } from 'src/app/enum/general-parameter-enums';
import { InventoryTransferStateEnums, InventoryTransferTypeEnums } from 'src/app/enum/inventory-transfer-enums';
import { OptionWindow } from 'src/app/enum/option-window-enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { FormatModel } from 'src/app/models/formats/format.model';
import { InventoryTransferModel } from 'src/app/models/inventory/inventory-transfer.model';
import { InventoryTransferPrintModel } from 'src/app/models/print/inventory/inventory-transfer-print.model';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { UserService } from 'src/app/services/authentication/user.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { FormatService } from 'src/app/services/formats/format.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { InventoryEntryService } from 'src/app/services/inventory/inventory-entry.service';
import { InventoryTransferDetailService } from 'src/app/services/inventory/inventory-transfer-detail.service';
import { InventoryTransferService } from 'src/app/services/inventory/inventory-transfer.service';
import { InventoryService } from 'src/app/services/inventory/inventory.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-register-inventory-transfer',
  templateUrl: './register-inventory-transfer.component.html',
  styleUrls: ['./register-inventory-transfer.component.scss'],
  standalone: false
})
export class RegisterInventoryTransferComponent implements OnInit {

  branchEntryId: number = 0;
  branchOutputId: number = 0;
  companyId: number = 0;
  consecutiveEntry: number = 0;
  consecutiveOutput: number = 0;
  disabledConfirmTransfer: boolean = false;
  disabledDetail: boolean = true;
  disabledForm: boolean = false;
  disabledState: boolean = false;
  finishLoadingPrint: boolean = false;
  formInventoryTransfer: FormGroup = new FormGroup({});
  formatModel: FormatModel = new FormatModel();
  iconStateButton: string = "pi pi-lock-open";
  inventoryId: number = 0;
  inventoryTransferId: number = 0;
  inventoryTransferModel: InventoryTransferModel = new InventoryTransferModel();
  inventoryTransferPrintModel: InventoryTransferPrintModel = new InventoryTransferPrintModel();
  isOpened: string | undefined = undefined;
  listBranches: any[] = [];
  listInventories: any[] = [];
  listStoresEntry: any[] = [];
  listStoresOutput: any[] = [];
  listTransporters: any[] = [];
  listTypes: any[] = [];
  listVehicles: any[] = [];
  nameWindow: string = 'Captura Traslados';
  permissionsUser: OptionWindowModel[] = [];
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  quantityDetails: number = 0;
  siesaSynchronization: boolean = false;
  severityState: string = "danger";
  stateInTransit: number = InventoryTransferStateEnums.inTransit;
  stateText: string = 'Abierto';
  swConfirmTransfer: boolean = false;
  titleStateButton: string = "";
  url: string = "inventory-transfer";
  userAuthenticatedIsADMIN: boolean = false;

  constructor(private activatedRoute: ActivatedRoute,
    private branchService: BranchService,
    private dateConverterService: DateConverterService,
    private formBuilder: FormBuilder,
    private formatService: FormatService,
    private headerService: HeaderService,
    private inventoryService: InventoryService,
    private inventoryEntryService: InventoryEntryService,
    private inventoryTransferService: InventoryTransferService,
    private inventoryTransferDetailService: InventoryTransferDetailService,
    private location: Location,
    private optionWindowService: OptionWindowService,
    private router: Router,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private userService: UserService,
    private windowService: WindowService) {

  }

  async ngOnInit() {
    await this.validateForm(new InventoryTransferModel());
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.headerService.setTitle(this.nameWindow);
    await this.getPermission();
    this.activatedRoute.params.subscribe(params => {
      this.inventoryTransferId = Object.keys(params).length > 0 ? params?.id : null;
    });
    this.handleInitialState();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  annulInventoryTransfer() {
    if (!this.validations()) return;

    if (this.inventoryTransferModel.state === InventoryTransferStateEnums.annul) {
      this.toastHandlerService.showToast('warning', 'El traslado se encuentra anulado.', 'Atención');
    } else {
      Swal.fire({
        title: 'Atención',
        text: "¿Realmente desea anular el traslado actual?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si',
        cancelButtonText: 'No'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            this.inventoryTransferModel = await firstValueFrom(this.inventoryTransferService.annulInventoryTransfer(this.inventoryTransferId));
            this.validateForm(this.inventoryTransferModel);
            this.toastHandlerService.showToast('success', 'El traslado fue anulado exitosament.', '');
          } catch (error) {
            console.error("Error al anular el traslado: ", error);
          }
        }
      });
    }
  }

  async areThereDetailsWithQuantity0() {
    return await firstValueFrom(this.inventoryTransferDetailService.areThereDetailsWithQuantity0(this.inventoryTransferId));
  }

  async changeConsecutive() {
    const inventoryId = this.formInventoryTransfer.get("inventoryId")?.value;
    let consecutive = this.formInventoryTransfer.get("consecutive")?.value;

    if (this.inventoryTransferModel.consecutive == consecutive) return;

    if (inventoryId == null || inventoryId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione un inventario.', 'Atención.');
      return;
    }

    consecutive = consecutive === 0 ? null : consecutive;
    if (consecutive == null) {
      await this.resetInventoryTransfer(inventoryId);
      return;
    }

    try {
      this.inventoryTransferModel = await firstValueFrom(this.inventoryTransferService.getInventoryTransferByKeysAsync(inventoryId, consecutive));
      this.inventoryTransferId = this.inventoryTransferModel.inventoryTransferId;
      await this.validateForm(this.inventoryTransferModel);
      this.location.replaceState(`/inventory-transfer/register/${this.inventoryTransferId}`);
    } catch (error) {
      this.handleInventoryTransferNotFound(inventoryId, consecutive);
      console.error('Error al buscar el traslado de inventario por campos de recuperación.', error);
    }
  }

  changeInventory() {
    this.inventoryTransferId = 0;
    const modelInventoryTransfer = new InventoryTransferModel();
    modelInventoryTransfer.inventoryId = this.inventoryId;
    this.inventoryTransferModel = modelInventoryTransfer;
    this.validateForm(modelInventoryTransfer);
  }

  async changeState() {
    if (!this.validations()) return;
    if (await this.areThereDetailsWithQuantity0()) {
      this.toastHandlerService.showToast('warning', 'No es posible modificar el estado, existen artículos con cantidad en cero o negativo', 'Atención');
      return;
    }
    try {
      this.inventoryTransferModel = await firstValueFrom(this.inventoryTransferService.setStateInventoryTransfer(this.inventoryTransferModel.inventoryTransferId));
      await this.validateForm(this.inventoryTransferModel);
      this.toastHandlerService.showToast('success', 'El estado del traslado de inventario se modificó exitosamente.');
    } catch (error) {
      console.error("Error al cambiar el estado del traslado.", error);
    }
  }

  changeValues() {
    this.disabledDetail = true;
    this.disabledState = true;
  }

  confirmTransfer() {
    if (!this.validations()) return;

    Swal.fire({
      title: 'Atención',
      text: "¿Realmente desea confirmar el traslado?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          this.inventoryTransferModel = await firstValueFrom(this.inventoryTransferService.confirmInventoryTransfer(this.inventoryTransferId));
          this.validateForm(this.inventoryTransferModel);
          this.toastHandlerService.showToast('success', 'El traslado fue confirmado exitosamente.', '');
        } catch (error) {
          console.error("Error al confirmar el traslado: ", error);
        }
      }
    });
  }

  async createNewInventoryTransfer() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', 'El usuario no tiene permisos para crear traslados de inventario. Comuníquese con el administrador del sistema');
      return;
    }

    this.inventoryTransferId = 0;
    this.inventoryTransferModel = new InventoryTransferModel();
    this.inventoryTransferModel.inventoryId = this.inventoryId;
    this.inventoryTransferModel.consecutive = 0;
    this.quantityDetails = 0;
    await this.validateForm(this.inventoryTransferModel);
    this.location.replaceState(`/inventory-transfer/register`);
  }

  async deleteInventoryTransfer() {
    if (!this.validations()) return;

    if (this.quantityDetails > 0) {
      this.toastHandlerService.showToast('warning', 'No es posible eliminar, el traslado de inventario tiene detalle.', 'Atención.');
      return;
    }

    const result = await Swal.fire({
      title: 'Atención',
      text: `¿Realmente desea eliminar el traslado de inventario ${this.inventoryTransferModel.consecutive}?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No'
    });
    if (result.isConfirmed) {
      try {
        await firstValueFrom(this.inventoryTransferService.deleteInventoryTransfer(this.inventoryTransferModel.inventoryTransferId));
        this.toastHandlerService.showToast('success', 'El traslado de inventario fue eliminado exitosamente.');
        this.createNewInventoryTransfer();
      } catch (error) {
        console.error('Error al eliminar el traslado de inventario.', error);
      }
    }
  }

  async editInventoryTransfer() {
    await this.getInventoryTransferById();
    await this.validateForm(this.inventoryTransferModel);
    this.inventoryId = this.inventoryTransferModel.inventoryId;
  }

  finishLoading(finish: boolean) {
    this.finishLoadingPrint = finish;
  }

  async getAllLists() {
    try {
      const [inventories, branches, transporters, vehicles] = await Promise.all([
        firstValueFrom(this.inventoryEntryService.getAllInventoriesForSelect()),
        firstValueFrom(this.branchService.getAllBranchesForSelectAsync()),
        firstValueFrom(this.inventoryTransferService.getAllTransportersForSelectAsync()),
        firstValueFrom(this.inventoryTransferService.getAllVehiclesForSelectAsync())
      ]);
      this.listInventories = inventories;
      this.listTypes = [
        {
          value: InventoryTransferTypeEnums.shop,
          label: 'Almacén'
        },
        {
          value: InventoryTransferTypeEnums.workshop2,
          label: 'Limpieza'
        },
        {
          value: InventoryTransferTypeEnums.workshop3,
          label: 'Reparación'
        }
      ]
      this.listBranches = branches;
      this.listTransporters = transporters;
      this.listVehicles = vehicles;

      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  async getBranch(branchId: number | null, output: boolean) {
    let validBranch = null;
    if (branchId != null) {
      const branch = await firstValueFrom(this.branchService.getBranchById(branchId));
      if (branch) {
        validBranch = branchId;
      }
    }
    if (output) {
      this.branchOutputId = validBranch ?? 0;
      this.listStoresOutput = await firstValueFrom(this.inventoryTransferService.getAllStoresForSelectAsync(this.inventoryId, this.branchOutputId))
      this.formInventoryTransfer.controls["storeOutputId"].patchValue(null);
    }
    else {
      this.branchEntryId = validBranch ?? 0;
      this.listStoresEntry = await firstValueFrom(this.inventoryTransferService.getAllStoresForSelectAsync(this.inventoryId, this.branchEntryId))
      this.formInventoryTransfer.controls["storeEntryId"].patchValue(null);
    }
    this.changeValues();
  }

  getButtonClick(buttonClick: any) {
    let consecutive = this.formInventoryTransfer.get("consecutive")?.value;
    const inventoryId = this.formInventoryTransfer.get("inventoryId")?.value;

    if (inventoryId == null || inventoryId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione un inventario.', 'Atención.');
      return;
    }

    consecutive = consecutive === 0 ? null : consecutive;
    this.handleInventoryTransferNavigation(buttonClick, inventoryId, consecutive);
  }

   async getCompanyById() {
      const company = await firstValueFrom(
        this.userAuthenticatedService.companyObservable.pipe(
          filter((company) => company && company.companyId !== 0),
        ),
      );
  
      this.siesaSynchronization =
        company.accountingSystemId === AccountingSystemEnums.siesaCloud;
    }

  async getFirstInventoryByCompanyAuthenticatedAsync() {
    const response = await firstValueFrom(this.inventoryService.getFirstInventoryByCompanyAuthenticatedAsync());
    this.inventoryId = response.inventoryId;
    await this.getInventory(response.inventoryId, false);
  }

  async getFormatByCompanyAndCode() {
    if (this.formatModel.formatId == 0)
      this.formatModel = await firstValueFrom(this.formatService.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.inventoryTransfer));
  }

  getGeneralParametersByCompany() {
    return new Promise((resolve) => {
      this.userAuthenticatedService.generalParameterObservable.subscribe(response => {
        this.swConfirmTransfer = response.some(x => x.generalParameterId === GeneralParameterEnums.confirmaTrasladoBodega);
      });
      resolve(true);
    });
  }

  async getInventory(inventoryId: number | null, reload: boolean) {
    let validInventory = null;

    if (inventoryId != null) {
      const inventory = await firstValueFrom(this.inventoryService.getInventoryById(inventoryId));
      if (inventory) {
        validInventory = inventoryId;
      }
    }

    this.inventoryId = validInventory ?? 0;
    this.formInventoryTransfer.controls["inventoryId"].patchValue(validInventory);

    if (reload) {
      this.changeInventory();
    }
  }

  async getInventoryTransferById() {
    try {
      this.inventoryTransferModel = await firstValueFrom(this.inventoryTransferService.getInventoryTransferById(this.inventoryTransferId));
    } catch (error) {
      console.error('Error al buscar el trasaldo de inventario.', error);
    }
  }

  async getInventoryTransferForPrint() {
    try {
      this.inventoryTransferPrintModel = await firstValueFrom(this.inventoryTransferService.getInventoryTransferForPrint(this.companyId, 0, this.inventoryTransferId));
    } catch (error) {
      console.error("Error al obtener el traslado a imprimir:", error);
      this.inventoryTransferPrintModel = new InventoryTransferPrintModel();
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast('warning', `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`);
      }
    } else {
      localStorage.clear();
    }

    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
      await this.getPermissionsForUserByWindow();
      await this.getGeneralParametersByCompany();
      await this.getCompanyById();

      await this.getAllLists();

    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async getPermissionsForUserByWindow() {
    const userAuthenticated = await firstValueFrom(this.userAuthenticatedService.userObservable.pipe(filter(user => user && user.userId !== 0)));
    this.companyId = userAuthenticated.companyId;
    this.userAuthenticatedIsADMIN = await firstValueFrom(this.userService.userAuthenticatedIsADMIN());
    this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.InventoryTransfer));
  }

  goToBack(event: Event) {
    event.preventDefault();
    this.router.navigate(['/inventory-transfer']);
  }

  goToHome(event: Event) {
    event.preventDefault();
    this.router.navigate(['/main']);
  }

  async handleInitialState() {
    if (this.inventoryTransferId !== null && this.inventoryTransferId !== 0) {
      await this.editInventoryTransfer();
    } else {
      await this.getFirstInventoryByCompanyAuthenticatedAsync();
      this.createNewInventoryTransfer();
    }
  }

  private handleInventoryTransferNotFound(inventoryId: number, consecutive: number): void {
    this.inventoryTransferModel = new InventoryTransferModel();
    this.inventoryTransferModel.inventoryId = inventoryId;
    this.inventoryTransferModel.consecutive = consecutive;
  }

  private async handleInventoryTransferNavigation(buttonClick: any, inventoryId: number, consecutive: number | null) {
    const actionMap: Record<string, () => Promise<InventoryTransferModel>> = {
      first: () => firstValueFrom(this.inventoryTransferService.getFirstInventoryTransferByKeysAsync(inventoryId)),
      previus: () => firstValueFrom(this.inventoryTransferService.getPreviusInventoryTransferByKeysAsync(inventoryId, consecutive)),
      next: () => firstValueFrom(this.inventoryTransferService.getNextInventoryTransferByKeysAsync(inventoryId, consecutive)),
      last: () => firstValueFrom(this.inventoryTransferService.getLastInventoryTransferByKeysAsync(inventoryId))
    };

    const action = actionMap[buttonClick.target.id];
    if (!action) {
      await this.resetInventoryTransfer(inventoryId);
      return;
    }

    try {
      const inventoryTransfer = await action();
      this.inventoryTransferModel = inventoryTransfer;
      this.inventoryTransferId = inventoryTransfer.inventoryTransferId;
      await this.validateForm(inventoryTransfer);
      this.location.replaceState(`/inventory-transfer/register/${this.inventoryTransferId}`);
    } catch (error) {
      this.handleInventoryTransferNotFound(inventoryId, 0);
      console.error(`Error al buscar el traslado de inventario (${buttonClick.target.id}).`, error);
    }
  }

  async printPage() {
    if (!this.validations()) return;

    if (!this.userAuthenticatedIsADMIN && this.permissionsUser.findIndex(x => x.code === OptionWindow.imprimir) !== -1) {
      this.toastHandlerService.showToast('warning', 'El usuario no tiene permisos para imprimir traslados.', 'Atención');
      return;
    }
    if (this.quantityDetails == 0) {
      this.toastHandlerService.showToast('warning', 'No es posible imprimir el traslado, no tiene ningún detalle', 'Atención');
      return;
    }

    if (await this.areThereDetailsWithQuantity0()) {
      this.toastHandlerService.showToast('warning', 'No es posible imprimir el traslado, existen artículos con cantidad en cero o negativo', 'Atención');
      return;
    }
    this.toastHandlerService.clearAllToasts();
    await this.getFormatByCompanyAndCode();
    await this.getInventoryTransferForPrint();

    this.finishLoadingPrint = false;
    await this.waitForComponenteImpresionToLoad();
  }

  reloadWindow(event: Event) {
    event.preventDefault();
    if (this.inventoryTransferId != 0 && this.inventoryTransferId != null) {
      this.router.navigate(['/inventory-transfer/register/', this.inventoryTransferId]);
    } else {
      this.router.navigate(['/inventory-transfer/register']);
    }
  }

  async resetInventoryTransfer(inventoryId: number) {
    this.inventoryTransferId = 0;
    this.inventoryTransferModel = new InventoryTransferModel();
    this.inventoryTransferModel.inventoryId = inventoryId;
    await this.validateForm(this.inventoryTransferModel);
  }

  async send() {
    Object.keys(this.formInventoryTransfer.controls).forEach(key => {
      const control = this.formInventoryTransfer.get(key);
      if (control && control.invalid) {
        console.warn(`${key} no es válido`, control.errors, 'value:', control.value);
      }
    });
    if (this.formInventoryTransfer.valid) {
      this.formInventoryTransfer.enable();

      const modelInventoryTransfer = this.formInventoryTransfer.value as InventoryTransferModel;

      if (modelInventoryTransfer.branchOutputId === modelInventoryTransfer.branchEntryId &&
        modelInventoryTransfer.storeOutputId === modelInventoryTransfer.storeEntryId) {
        this.toastHandlerService.showToast('error', 'La bodega de envío debe ser diferente a la bodega de recepción', 'Atención.');
        return;
      }

      //Hago null, los campos que permiten ser nulos:
      if (modelInventoryTransfer.observation?.trim() === "") modelInventoryTransfer.observation = null;

      if (this.inventoryTransferId === 0) {
        try {
          this.inventoryTransferModel = await firstValueFrom(this.inventoryTransferService.createInventoryTransfer(modelInventoryTransfer));
          this.inventoryTransferId = this.inventoryTransferModel.inventoryTransferId;
          this.validateForm(this.inventoryTransferModel);
          this.location.replaceState(`/inventory-transfer/register/${this.inventoryTransferId}`);
          this.toastHandlerService.showToast('success', 'El traslado fue creado exitosamente.');
        } catch (error) {
          console.error('Error al crear el traslado.', error);
        }
      } else {
        this.inventoryTransferModel.type = modelInventoryTransfer.type;
        this.inventoryTransferModel.dateOutput = modelInventoryTransfer.dateOutput;
        this.inventoryTransferModel.dateEntry = modelInventoryTransfer.dateEntry;
        this.inventoryTransferModel.storeOutputId = modelInventoryTransfer.storeOutputId;
        this.inventoryTransferModel.storeEntryId = modelInventoryTransfer.storeEntryId;
        this.inventoryTransferModel.transporterId = modelInventoryTransfer.transporterId;
        this.inventoryTransferModel.vehicleId = modelInventoryTransfer.vehicleId;
        this.inventoryTransferModel.transportValue = modelInventoryTransfer.transportValue;
        this.inventoryTransferModel.observation = modelInventoryTransfer.observation;

        try {
          this.inventoryTransferModel = await firstValueFrom(this.inventoryTransferService.updateInventoryTransfer(this.inventoryTransferModel));
          this.validateForm(this.inventoryTransferModel);
          this.toastHandlerService.showToast(
            'success',
            'El traslado fue modificada exitosamente.'
          );
        } catch (error) {
          console.error('Error al actualizar el traslado.', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      inventoryId: {
        required: 'El campo inventario es obligatorio.',
        min: 'Debes seleccionar un inventario válido.'
      },
      type: {
        required: 'El campo tipo es obligatorio.',
        min: 'Debes seleccionar un tipo válido.'
      },
      dateOutput: {
        required: 'La fecha de envío es obligatoria.'
      },
      dateEntry: {
        required: 'La fecha de recepción es obligatoria.'
      },
      storeOutputId: {
        required: 'El campo bodega de envío es obligatorio.',
        min: 'Debes seleccionar una bodega de envío válida.'
      },
      storeEntryId: {
        required: 'El campo bodega de recepción es obligatorio.',
        min: 'Debes seleccionar una bodega de recepción válida.'
      },
      transporterId: {
        required: 'El campo transportador es obligatorio.',
        min: 'Debes seleccionar un transportador válido.'
      },
      vehicleId: {
        required: 'El campo vehículo es obligatorio.',
        min: 'Debes seleccionar un vehículo válido.'
      },
      transportValue: {
        required: 'El valor del transporte es obligatorio.',
        min: 'El valor del transporte no puede ser negativo.'
      },
      observation: {
        maxlength: 'La observación no puede tener más de 250 caracteres.'
      }
    };

    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formInventoryTransfer.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  async updateFormState() {
    const stateConfig: any = {
      [InventoryTransferStateEnums.open]: {
        severity: 'danger',
        icon: 'pi pi-lock-open',
        title: 'Cerrar',
        text: 'Abierta',
        disabledDetail: this.inventoryTransferId === 0,
        disabledForm: false,
        disabledState: this.inventoryTransferId === 0,
        enableConsecutive: this.inventoryTransferId !== 0,
        disabledConfirmTransfer: true
      },
      [InventoryTransferStateEnums.close]: {
        severity: 'success',
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Cerrada',
        disabledDetail: true,
        disabledForm: true,
        disabledState: false,
        enableConsecutive: true,
        disabledConfirmTransfer: true
      },
      [InventoryTransferStateEnums.annul]: {
        severity: 'warn',
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Anulada',
        disabledForm: true,
        disabledDetail: true,
        disabledState: true,
        enableConsecutive: true,
        disabledConfirmTransfer: true
      },
      [InventoryTransferStateEnums.inTransit]: {
        severity: 'info',
        icon: 'pi pi-replay',
        title: 'Abrir',
        text: 'En Transito',
        disabledDetail: true,
        disabledForm: true,
        disabledState: false,
        enableConsecutive: true,
        disabledConfirmTransfer: false
      },
    }

    const currentState = this.inventoryTransferModel.state;
    const config = stateConfig[currentState];

    if (config) {
      this.iconStateButton = config.icon;
      this.titleStateButton = config.title;
      this.stateText = config.text;
      this.disabledDetail = config.disabledDetail;
      this.disabledForm = config.disabledForm;
      this.disabledState = config.disabledState;
      this.disabledConfirmTransfer = config.disabledConfirmTransfer;

      setTimeout(() => {
        config.disabledForm ? this.formInventoryTransfer.disable() : this.formInventoryTransfer.enable();
        setTimeout(() => this.formInventoryTransfer.controls["inventoryId"].enable(), 100);
        const control = this.formInventoryTransfer.controls["consecutive"];
        config.enableConsecutive ? control.enable() : control.disable();
      }, 100);
    }
    if (!this.permissionUpdatable) {
      setTimeout(() => this.formInventoryTransfer.disable(), 100);
      setTimeout(() => this.formInventoryTransfer.controls["inventoryId"].enable(), 100);
      setTimeout(() => this.formInventoryTransfer.controls["consecutive"].enable(), 100);
    }
  }

  validations() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', 'El usuario no tiene permisos para modificar traslados de inventario. Comuníquese con el administrador del sistema.', 'Atención.');
      return false;
    }

    if (this.inventoryTransferModel.inventoryTransferId == 0) {
      this.toastHandlerService.showToast('warning', 'Debe crear el encabezado del traslado de inventario.', 'Atención.');
      return false;
    }
    return true;
  }

  async validateForm(inventoryTransfer: InventoryTransferModel) {
    this.inventoryId = inventoryTransfer.inventoryId;
    this.branchOutputId = inventoryTransfer.branchOutputId;
    this.branchEntryId = inventoryTransfer.branchEntryId;
    if (inventoryTransfer.branchOutputId != 0) {
      this.listStoresOutput = await firstValueFrom(this.inventoryTransferService.getAllStoresForSelectAsync(this.inventoryId, this.branchOutputId));
    }
    if (inventoryTransfer.branchEntryId != 0) {
      this.listStoresEntry = await firstValueFrom(this.inventoryTransferService.getAllStoresForSelectAsync(this.inventoryId, this.branchEntryId));
    }

    this.formInventoryTransfer = this.formBuilder.group({
      inventoryId: [inventoryTransfer.inventoryId, [Validators.required, Validators.min(1)]],
      consecutive: [inventoryTransfer.consecutive, []],
      type: [inventoryTransfer.type, [Validators.required, Validators.min(1)]],
      dateOutput: [inventoryTransfer.dateOutput ?
        this.dateConverterService.convertUtcToLocalDate(inventoryTransfer.dateOutput) : null, [Validators.required]],
      dateEntry: [inventoryTransfer.dateEntry ?
        this.dateConverterService.convertUtcToLocalDate(inventoryTransfer.dateEntry) : null, [Validators.required]],
      branchOutputId: [inventoryTransfer.branchOutputId, [Validators.required, Validators.min(1)]],
      storeOutputId: [inventoryTransfer.storeOutputId, [Validators.required, Validators.min(1)]],
      branchEntryId: [inventoryTransfer.branchEntryId, [Validators.required, Validators.min(1)]],
      storeEntryId: [inventoryTransfer.storeEntryId, [Validators.required, Validators.min(1)]],
      transporterId: [inventoryTransfer.transporterId, [Validators.required, Validators.min(1)]],
      vehicleId: [inventoryTransfer.vehicleId, [Validators.required, Validators.min(1)]],
      transportValue: [inventoryTransfer.transportValue, [Validators.required, Validators.min(0)]],
      observation: [inventoryTransfer.observation, [Validators.maxLength(250)]]
    });

    setTimeout(() => {
      this.formInventoryTransfer.controls["storeOutputId"].patchValue(inventoryTransfer.storeOutputId)
      this.formInventoryTransfer.controls["storeEntryId"].patchValue(inventoryTransfer.storeEntryId)
    }, 100);

    if (inventoryTransfer.inventoryTransferId != 0) {
      const consecutives = await firstValueFrom(this.inventoryTransferService.getConsecutiveEntryAndOutputByInventoryTransferId(inventoryTransfer.inventoryTransferId));
      this.consecutiveEntry = consecutives.consecutiveEntry;
      this.consecutiveOutput = consecutives.consecutiveOutput;
    } else {
      this.consecutiveEntry = 0;
      this.consecutiveOutput = 0;
    }
    this.updateFormState();
  }

  waitForComponenteImpresionToLoad(): Promise<void> {
    return new Promise<void>((resolve) => {
      const check = async () => {
        if (this.finishLoadingPrint) {
          print();
          resolve();
        } else {
          setTimeout(check, 100);
        }
      };
      check();
    });
  }
}
